import { Directive, Provider } from '@angular/core';
import { AppContextDirective } from '@modules/common/directives/app-context.directive';
import { BaseAppStateService } from '@modules/common/services/base-app-state.service';
import { ContactsAppStateService } from '../services/state.service';
import { ContactsWorkspaceStateService } from '../services/contacts-workspace-state.service';

@Directive({
  selector: '[appContactsAppContext]',
  standalone: true,
})
export class ContactsAppContextDirective extends AppContextDirective {
  static readonly providers = [
    ContactsWorkspaceStateService,
    ...BaseAppStateService.provideAs(ContactsAppStateService),
  ];

  protected getProviders(): Provider[] {
    return ContactsAppContextDirective.providers;
  }
}
